import { ThemeColorsV2 } from '#app/theme/index.js';

export const avatarFallbackColors: ThemeColorsV2[] = [
  'brandPurple',
  'brandPink',
  'brandRed',
  'black',
  'gray10',
  'brandLilac',
  'brandBlue',
  'brandYellow',
];

export const getRandomAvatarFallbackColor = (index?: number): ThemeColorsV2 => {
  if (index !== undefined) {
    return avatarFallbackColors[index % avatarFallbackColors.length];
  }

  return avatarFallbackColors[
    Math.floor(Math.random() * avatarFallbackColors.length)
  ];
};
